import { updateLinksAttributes } from '../utils/handleAttributes';
import { missingWidget } from '../utils/helpers';

export default function footerLinks() {
  const widgetName = 'footerLinks';
  const $widget = $(`#${widgetName}`);
  const widgetOpts = typeof footerLinksOpts === 'undefined' ? null : footerLinksOpts;

  if (!widgetOpts) {
    $widget.remove();
    missingWidget(widgetName);
    return;
  }

  return saffire.widgets.cardWidget($widget, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 14,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createFooterLinks(data.items);
      } else {
        $widget.remove();
      }
    },
  });

  function createFooterLinks(widgetData) {
    $widget.find('.card-widget-item').each(function (x) {
      const { Title, URL } = widgetData[x];
      const $item = $(this);

      if (URL == null) {
        $item.remove();
      } else {
        $item.replaceWith(
          `<a class="footer-item" href="${URL}" ${updateLinksAttributes(URL, Title)} >${Title}</a>`,
        );
      }
    });
  }
}
